import DictPreference from "../../../components/dict/DictPreference";

const Widget = () => {
  return <DictPreference />;
};

export default Widget;
